import { IMAGE_PLACEHOLDERS } from '#build/image-placeholders.mjs';

/**
 * The blurred thumbnail the build derived from a first-render image of `public/images`, as a data URI.
 *
 * @param source - the image path a `UiCustomResponsivePicture` takes as `src`
 * @returns the data URI, or `undefined` for an image the build did not thumbnail
 * @example imagePlaceholder('home/hero/default.webp') // 'data:image/webp;base64,…'
 * @example imagePlaceholder('common/footer/accreditations/iata.png') // undefined
 */
export const imagePlaceholder = (source: string): string | undefined => IMAGE_PLACEHOLDERS[source];
